import { useEffect, useState, useRef } from "react";
import "./index.css";
import { Button, Spinner } from "reactstrap";
import styled from "styled-components";
export const AddNewCommentBtnDiv = styled<any>("div")`
  width: ${(props: any) => (props.viewAllComments ? "100%" : "100%")};
  display: flex;
  align-items: center;
  padding: 10px;
  border-top: 1px solid var(--Grey-50, #afafaf);
  background: #fff;
  padding: 0px;
  justify-content: center;
`;
const TotalCharactersCount = 2000;
const SendCommentBox = ({
  viewAllComments,
  loadingSave,
  filterState,
  setFilterState,
  sendCommenthandler,
  isCommentEdit,
}: any) => {
  const [characterCount, setcharacterCount] = useState<number>(0);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const handleChang = (e: any) => {
    const value = e.target.value;
    const inputValueWithoutSpaces = value.replace(/^\s+/g, "");
    if (inputValueWithoutSpaces.length <= TotalCharactersCount) {
      setcharacterCount(inputValueWithoutSpaces.length);
      setFilterState({
        ...filterState,
        comment: inputValueWithoutSpaces,
      });
    }
  };
  const showExpectedReturnDate =
    filterState.subj === "general" && filterState.type === "absentee";
  const disabledHandler = () => {
    console.log(filterState, "filterState");
    if (
      filterState.comment != "" &&
      ["followup", "absentee"].includes(filterState.type) &&
      filterState.lopAction != null &&
      filterState.lopAction != undefined &&
      ["followup", "absentee"].includes(filterState.type) &&
      filterState.lopReason &&
      filterState.lopReason != null &&
      filterState.lopReason.length > 0 &&
      (!showExpectedReturnDate || filterState.expectedReturnDate)
    ) {
      return false;
    } else if (
      filterState.comment != "" &&
      !["followup", "absentee"].includes(filterState.type)
    ) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if (filterState.comment != "") {
      setcharacterCount(filterState.comment.length);
    }
  }, [filterState]);
  const handleButtonClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  useEffect(() => {
    if (isCommentEdit) {
      handleButtonClick();
    }
  }, [isCommentEdit]);
  return (
    <div>
      <div className="sendCommentBoxDiv">
        <input
          type="text"
          placeholder="Add a comment..."
          className="sendCommentInput"
          value={filterState.comment}
          onChange={handleChang}
          maxLength={TotalCharactersCount}
          ref={inputRef}
        />
        {filterState.comment != "" && (
          <div
            className={
              characterCount === TotalCharactersCount
                ? "charactersCount pl-2"
                : "normalCharacterCount pl-2"
            }
          >
            {characterCount}/{TotalCharactersCount}
          </div>
        )}
      </div>
      <AddNewCommentBtnDiv viewAllComments={viewAllComments}>
        <Button
          disabled={disabledHandler()}
          color={
            disabledHandler()
              ? "aeslDraft footerAddCommentBtn"
              : "aeslPrimary footerAddCommentBtn"
          }
          onClick={sendCommenthandler}
          className="d-flex justify-content-center w-100"
        >
          {loadingSave ? (
            <Spinner color="info"></Spinner>
          ) : (
            <span>{isCommentEdit ? "Edit Comment" : "Add Comment"}</span>
          )}
        </Button>
      </AddNewCommentBtnDiv>
    </div>
  );
};

export default SendCommentBox;
